import axios from 'axios'
import store from '../../store/index'

const state = {
}

const mutations = {
}

const actions = {
  getDashboardStats ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/dashboard',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  getDashboardProfitStats ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/dashboard/charges',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
